module.exports = __webpack_public_path__ + "static/media/BPS.dcdac404.jpg";